/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 2;
export const WallType = new EnumReflection('WallType', {
    enum: [
        'A',
        'B',
        'C'
    ]
});
export const WallDirection = new EnumReflection('WallDirection', {
    enum: [
        'left',
        'right'
    ]
});
export const CornerFillerType = new EnumReflection('CornerFillerType', {
    enum: [
        'AB',
        'BC'
    ]
});
export const Handing = new EnumReflection('Handing', {
    enum: [
        'left',
        'right',
        'top',
        'both',
        'none'
    ]
});
export const RoomShapeType = new EnumReflection('RoomShapeType', {
    enum: [
        'L',
        'U',
        'I'
    ]
});
export const CabinetColor = new EnumReflection('CabinetColor', {
    type: 'string',
    enum: [
        'Stainless',
        'Obsidian',
        'Glacier',
        'PacificBlue',
        'CaliforniaPoppy',
        'Surf',
        'DesertSage',
        'Limestone',
        'Sierra'
    ]
});
export const FuelType = new EnumReflection('FuelType', {
    type: 'string',
    enum: [
        'None',
        'Propane',
        'NaturalGas'
    ]
});
export const GrillBaseVariant = new EnumReflection('GrillBaseVariant', {
    type: 'string',
    enum: [
        'Default',
        'WithWarmingDrawer'
    ]
});
export const LynxProfessionalGrillVariant = new EnumReflection('LynxProfessionalGrillVariant', {
    type: 'string',
    enum: [
        'AllCeramic',
        'AllTrident',
        'TridentAndCeramic'
    ]
});
export const LynxSedonaGrillVariant = new EnumReflection('LynxSedonaGrillVariant', {
    type: 'string',
    enum: [
        'ProSear_SsBurner1',
        'ProSear_SsBurner1_Rotisserie',
        'SsBurner3',
        'ProSear_SsBurner2',
        'SsBurner3_Rotisserie',
        'ProSear_SsBurner2_Rotisserie'
    ]
});
export const WallSummaryItem = new AjvReflection('WallSummaryItem', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        sku: {
            type: 'string'
        },
        price: {
            type: 'number'
        },
        thumbnailUrl: {
            type: 'string'
        }
    },
    required: [
        'id',
        'name',
        'sku',
        'price'
    ],
    additionalProperties: false
});
export const WallSummary = new AjvReflection('WallSummary', {
    type: 'object',
    properties: {
        id: {
            type: 'string'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        id: {
                            type: 'string'
                        },
                        comment: {
                            type: 'string'
                        },
                        message: {
                            type: 'string'
                        },
                        values: {
                            type: 'object',
                            additionalProperties: true
                        }
                    },
                    required: [
                        'id'
                    ],
                    additionalProperties: false
                }
            ]
        },
        cabinets: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        parts: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        },
        appliances: {
            type: 'array',
            items: WallSummaryItem._meta.schema
        }
    },
    required: [
        'id',
        'name',
        'cabinets',
        'parts',
        'appliances'
    ]
});
const AdjustableDoorCabinetShape = new AjvReflection('AdjustableDoorCabinetShape', {
    type: 'object',
    properties: {
        handing: Handing._meta.schema
    },
    additionalProperties: false,
    required: [
        'handing'
    ]
});
const RearPanelShape = new AjvReflection('RearPanelShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762,
                914.4,
                1066.8,
                1219.2,
                1371.6,
                1524,
                1676.4,
                1828.8,
                1981.2,
                2133.6,
                2286,
                2438.4
            ]
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'width'
    ]
});
const CabinetWithApplianceShape = new AjvReflection('CabinetWithApplianceShape', {
    type: 'object',
    properties: {
        applianceId: {
            anyOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'applianceId'
    ]
});
const WallItemShape = new AjvReflection('WallItemShape', {
    type: 'object',
    properties: {
        wallId: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        x: {
            type: 'number'
        }
    },
    additionalProperties: false,
    required: [
        'wallId',
        'x'
    ]
});
const Drawer33Door66Shape = new AjvReflection('Drawer33Door66Shape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const FillerShape = new AjvReflection('FillerShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                25.4,
                31.75,
                38.1,
                44.45,
                50.8,
                57.15,
                63.5,
                69.85,
                76.2,
                82.55,
                88.9,
                95.25,
                101.6,
                107.95,
                114.3,
                120.65,
                127
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const FullDoorBaseShape = new AjvReflection('FullDoorBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                304.8,
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const GrillBaseShape = new AjvReflection('GrillBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                914.4,
                1066.8,
                1219.2,
                1524
            ]
        },
        variant: GrillBaseVariant._meta.schema
    },
    additionalProperties: false,
    required: [
        'width',
        'variant'
    ]
});
const LynxProfessionalGrillW30Shape = new AjvReflection('LynxProfessionalGrillW30Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW36Shape = new AjvReflection('LynxProfessionalGrillW36Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW42Shape = new AjvReflection('LynxProfessionalGrillW42Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxProfessionalGrillW54Shape = new AjvReflection('LynxProfessionalGrillW54Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW30Shape = new AjvReflection('LynxSedonaGrillW30Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW36Shape = new AjvReflection('LynxSedonaGrillW36Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSedonaGrillW42Shape = new AjvReflection('LynxSedonaGrillW42Shape', {
    type: 'object',
    properties: {
        variant: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'variant'
    ]
});
const LynxSinkShape = new AjvReflection('LynxSinkShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6,
                762
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const RoomShape = new AjvReflection('RoomShape', {
    type: 'object',
    properties: {
        shape: RoomShapeType._meta.schema,
        cabinetColor: CabinetColor._meta.schema,
        fuelType: FuelType._meta.schema,
        includeCabinets: {
            type: 'boolean'
        },
        includeGrill: {
            type: 'boolean'
        },
        includeBurner: {
            type: 'boolean'
        },
        includeOtherCookingItem: {
            type: 'boolean'
        },
        includeHood: {
            type: 'boolean'
        },
        includeRefrigerator: {
            type: 'boolean'
        },
        includeSink: {
            type: 'boolean'
        },
        stainlessSafeEnvironment: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'shape',
        'cabinetColor',
        'fuelType',
        'includeCabinets',
        'includeGrill',
        'includeBurner',
        'includeOtherCookingItem',
        'includeHood',
        'includeRefrigerator',
        'includeSink',
        'stainlessSafeEnvironment'
    ]
});
const SinkBaseShape = new AjvReflection('SinkBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                609.6,
                762,
                914.4,
                1219.2
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const ThreeDrawerBaseShape = new AjvReflection('ThreeDrawerBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const TrashPulloutBaseShape = new AjvReflection('TrashPulloutBaseShape', {
    type: 'object',
    properties: {
        width: {
            type: 'number',
            enum: [
                457.2,
                609.6
            ]
        }
    },
    additionalProperties: false,
    required: [
        'width'
    ]
});
const WallShape = new AjvReflection('WallShape', {
    type: 'object',
    properties: {
        wallType: WallType._meta.schema,
        length: {
            type: 'number'
        },
        fullHeight: {
            type: 'boolean'
        },
        hidden: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'wallType',
        'length',
        'fullHeight',
        'hidden'
    ]
});
const CornerFillerShape = new AjvReflection('CornerFillerShape', {
    type: 'object',
    properties: {
        cornerFillerType: CornerFillerType._meta.schema
    },
    additionalProperties: false,
    required: [
        'cornerFillerType'
    ]
});
export const BurnerBaseW18 = new DomainEntityReflection('BurnerBaseW18', [
    AdjustableDoorCabinetShape._meta.schema,
    CabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const BurnerBaseW24 = new DomainEntityReflection('BurnerBaseW24', [
    AdjustableDoorCabinetShape._meta.schema,
    CabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const CornerFiller = new DomainEntityReflection('CornerFiller', [
    CornerFillerShape._meta.schema
]);
export const Drawer33Door66 = new DomainEntityReflection('Drawer33Door66', [
    Drawer33Door66Shape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoBaseW36 = new DomainEntityReflection('EvoBaseW36', [
    AdjustableDoorCabinetShape._meta.schema,
    CabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const EvoAffinity25G = new DomainEntityReflection('EvoAffinity25G', []);
export const EvoAffinity30G = new DomainEntityReflection('EvoAffinity30G', []);
export const Filler = new DomainEntityReflection('Filler', [
    FillerShape._meta.schema,
    WallItemShape._meta.schema
]);
export const FullDoorBase = new DomainEntityReflection('FullDoorBase', [
    FullDoorBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const GrillBase = new DomainEntityReflection('GrillBase', [
    GrillBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    CabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const LynxAsadoGriddgle = new DomainEntityReflection('LynxAsadoGriddgle', []);
export const LynxProfessionalCocktailStation = new DomainEntityReflection('LynxProfessionalCocktailStation', []);
export const LynxProfessionalGrillW30 = new DomainEntityReflection('LynxProfessionalGrillW30', [
    LynxProfessionalGrillW30Shape._meta.schema
]);
export const LynxProfessionalGrillW36 = new DomainEntityReflection('LynxProfessionalGrillW36', [
    LynxProfessionalGrillW36Shape._meta.schema
]);
export const LynxProfessionalGrillW42 = new DomainEntityReflection('LynxProfessionalGrillW42', [
    LynxProfessionalGrillW42Shape._meta.schema
]);
export const LynxProfessionalGrillW54 = new DomainEntityReflection('LynxProfessionalGrillW54', [
    LynxProfessionalGrillW54Shape._meta.schema
]);
export const LynxProfessionalSingleBurner = new DomainEntityReflection('LynxProfessionalSingleBurner', []);
export const LynxProfessionalDoubleBurner = new DomainEntityReflection('LynxProfessionalDoubleBurner', []);
export const LynxProfessionalPowerBurner = new DomainEntityReflection('LynxProfessionalPowerBurner', []);
export const LynxSedonaGrillW30 = new DomainEntityReflection('LynxSedonaGrillW30', [
    LynxSedonaGrillW30Shape._meta.schema
]);
export const LynxSedonaGrillW36 = new DomainEntityReflection('LynxSedonaGrillW36', [
    LynxSedonaGrillW36Shape._meta.schema
]);
export const LynxSedonaGrillW42 = new DomainEntityReflection('LynxSedonaGrillW42', [
    LynxSedonaGrillW42Shape._meta.schema
]);
export const LynxSedonaSingleBurner = new DomainEntityReflection('LynxSedonaSingleBurner', []);
export const LynxSedonaDoubleBurner = new DomainEntityReflection('LynxSedonaDoubleBurner', []);
export const LynxSinkW18 = new DomainEntityReflection('LynxSinkW18', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW24 = new DomainEntityReflection('LynxSinkW24', [
    LynxSinkShape._meta.schema
]);
export const LynxSinkW30 = new DomainEntityReflection('LynxSinkW30', [
    LynxSinkShape._meta.schema
]);
export const Room = new DomainEntityReflection('Room', [
    RoomShape._meta.schema
]);
export const RearPanel = new DomainEntityReflection('RearPanel', [
    RearPanelShape._meta.schema
]);
export const SinkBase = new DomainEntityReflection('SinkBase', [
    SinkBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    CabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema
]);
export const ThreeDrawerBase = new DomainEntityReflection('ThreeDrawerBase', [
    ThreeDrawerBaseShape._meta.schema,
    WallItemShape._meta.schema
]);
export const TrashPulloutBase = new DomainEntityReflection('TrashPulloutBase', [
    TrashPulloutBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    WallItemShape._meta.schema
]);
export const Wall = new DomainEntityReflection('Wall', [
    WallShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    Filler,
    FullDoorBase,
    GrillBase,
    LynxAsadoGriddgle,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Room
]);
export const StaticEntity = new RawAliasReflection('StaticEntity', [
    Room,
    Wall,
    CornerFiller
]);
export const AdjustableDoorCabinet = new RawAliasReflection('AdjustableDoorCabinet', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    SinkBase,
    TrashPulloutBase
]);
export const Appliance = new RawAliasReflection('Appliance', [
    LynxAsadoGriddgle,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxProfessionalCocktailStation,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    EvoAffinity25G,
    EvoAffinity30G
]);
export const BurnerBase = new RawAliasReflection('BurnerBase', [
    BurnerBaseW18,
    BurnerBaseW24
]);
export const LynxSink = new RawAliasReflection('LynxSink', [
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30
]);
export const Cabinet = new RawAliasReflection('Cabinet', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const CabinetWithAppliance = new RawAliasReflection('CabinetWithAppliance', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
    SinkBase
]);
export const CabinetWithoutAppliance = new RawAliasReflection('CabinetWithoutAppliance', [
    Drawer33Door66,
    FullDoorBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const CabinetWithDefaultDetail = new RawAliasReflection('CabinetWithDefaultDetail', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    Drawer33Door66,
    FullDoorBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const Part = new RawAliasReflection('Part', [
    Filler,
    RearPanel
]);
export const WallItemWithDefaultCountertop = new RawAliasReflection('WallItemWithDefaultCountertop', [
    Drawer33Door66,
    Filler,
    FullDoorBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const WallItemWithCustomCountertop = new RawAliasReflection('WallItemWithCustomCountertop', [
    BurnerBaseW18,
    BurnerBaseW24,
    EvoBaseW36,
    GrillBase,
    SinkBase
]);
export const WallItemWithDefaultToeKick = new RawAliasReflection('WallItemWithDefaultToeKick', [
    BurnerBaseW18,
    BurnerBaseW24,
    Drawer33Door66,
    EvoBaseW36,
    Filler,
    FullDoorBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const WallItemWithCustomToeKick = new RawAliasReflection('WallItemWithCustomToeKick', [
    GrillBase
]);
export const WallItemWithBackPanel = new RawAliasReflection('WallItemWithBackPanel', [
    ...Cabinet.reflections,
    Filler
]);
export const RoomItem = new RawAliasReflection('RoomItem', [
    ...Appliance.reflections,
    ...Cabinet.reflections,
    ...Part.reflections
]);
export const WallItem = new RawAliasReflection('WallItem', [
    ...Cabinet.reflections,
    Filler
]);
export const LynxProfessionalGrill = new RawAliasReflection('LynxProfessionalGrill', [
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54
]);
export const LynxSedonaGrill = new RawAliasReflection('LynxSedonaGrill', [
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42
]);
export const ResizableWallItem = new RawAliasReflection('ResizableWallItem', [
    Drawer33Door66,
    GrillBase,
    Filler,
    FullDoorBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    StaticEntity: StaticEntity.types,
    AdjustableDoorCabinet: AdjustableDoorCabinet.types,
    Appliance: Appliance.types,
    BurnerBase: BurnerBase.types,
    LynxSink: LynxSink.types,
    Cabinet: Cabinet.types,
    CabinetWithAppliance: CabinetWithAppliance.types,
    CabinetWithoutAppliance: CabinetWithoutAppliance.types,
    CabinetWithDefaultDetail: CabinetWithDefaultDetail.types,
    Part: Part.types,
    WallItemWithDefaultCountertop: WallItemWithDefaultCountertop.types,
    WallItemWithCustomCountertop: WallItemWithCustomCountertop.types,
    WallItemWithDefaultToeKick: WallItemWithDefaultToeKick.types,
    WallItemWithCustomToeKick: WallItemWithCustomToeKick.types,
    WallItemWithBackPanel: WallItemWithBackPanel.types,
    RoomItem: RoomItem.types,
    WallItem: WallItem.types,
    LynxProfessionalGrill: LynxProfessionalGrill.types,
    LynxSedonaGrill: LynxSedonaGrill.types,
    ResizableWallItem: ResizableWallItem.types
};
export const entities = {
    BurnerBaseW18,
    BurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    Filler,
    FullDoorBase,
    GrillBase,
    LynxAsadoGriddgle,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall
};

//# sourceMappingURL=v2.js.map